import { createSlice } from "@reduxjs/toolkit";
const textChangeSlice = createSlice({
  name: "textChange",
  initialState: {},
  reducers: {
    textChange(state, action) {
      state.value = action.payload;
    },
  },
});
export { textChangeSlice };
export const { textChange } = textChangeSlice.actions;
